// src/routes.tsx //precisa ajustar permissoes conferencia
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/routing/ProtectedRoute';
import ProtectedLayout from './components/layout/ProtectedLayout';
import Home from './pages/home/Home';
import Usuarios from './pages/users/Usuarios';
import Requisicoes from './pages/po/Requisicoes';
import Compras from './pages/po/Compras';
import Integracoes from './pages/connection/Integracoes';
import Parametrizacao from './pages/parametrizacao/Parametrizacao';
import Login from './pages/auth/Login';
import RedefinirSenha from './pages/auth/RedefinirSenha';
import DefinirNovaSenha from './pages/auth/DefinirNovaSenha';
import MsalCallbackTarget from './pages/auth/MsalCallbackTarget';
import Conferencia from './pages/common/Conferencia';
import ContratoBluelt from './pages/contrato/ContratoBluelt';
import BlueBi from './pages/bluebi/BlueBi';
import PainelView from './pages/bluebi/PainelView';

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/microsoft/callback" element={<MsalCallbackTarget />} />
      <Route path="/auth/microsoft/callback/*" element={<MsalCallbackTarget />} />
      <Route path="/password-reset" element={<RedefinirSenha />} />
      <Route path="/password-reset/confirm" element={<DefinirNovaSenha />} />
      <Route element={<ProtectedRoute><ProtectedLayout /></ProtectedRoute>}>
        <Route path="home" element={<Home />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="requisicoes" element={<Requisicoes />} />
        <Route path="compras" element={<Compras />} />
        <Route path="integracoes" element={<Integracoes />} />
        <Route path="parametrizacao" element={<Parametrizacao />} />
        <Route path="conferencia" element={<Conferencia />} />
        <Route path="contrato" element={<ContratoBluelt />} />
        <Route path="bluebi" element={<BlueBi />} />
        {/* O segmento é o SLUG do rótulo do painel, nunca o link do Power B.I. — que é
            anônimo e público (issue #42 §1). O gate desta subrota fica no próprio
            PainelView: o routePermissions do ProtectedRoute casa path por igualdade. */}
        <Route path="bluebi/:nome" element={<PainelView />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  </Router>
);

export default AppRoutes;
